import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { fetchAndPrepareImage } from 'utils/helpers';

interface ImageItem {
    title: string;
    img: string;
}

interface ImageListProp {
    itemData: ImageItem[];
    setImgValue: any;
    clickedIndex: any;
    setClickedIndex: any;
}
const imageStyles = {
    cursor: 'pointer',
    transition: 'transform 0.2s',
    '&:hover': {
        transform: 'scale(1.1)',
    },
    '&:active': {
        transform: 'scale(0.9)',
    },
    margin: 0.5,
    height: 130,
    width: 120,
};

export default function StandardImageList({ itemData, setImgValue, clickedIndex, setClickedIndex }: ImageListProp) {
    const handleClick = async (index: any, img: any) => {
        setClickedIndex(index);
        const file = await fetchAndPrepareImage(img);
        setImgValue(file);
    };
    return (
        <ImageList sx={{ width: '100%', height: '100%', padding: 2 }} cols={6} rowHeight={120}>
            {itemData.map((item, index) => {
                return (
                    <ImageListItem
                        key={item.img}
                        sx={{
                            ...imageStyles,
                            transform: index === clickedIndex ? 'scale(1.1)' : 'scale(1)',
                            opacity: index === clickedIndex ? 1 : 0.7,
                        }}
                    >
                        <img
                            srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                            src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
                            alt={item.title}
                            loading="lazy"
                            onClick={() => handleClick(index, item.img)}
                        />
                    </ImageListItem>
                );
            })}
        </ImageList>
    );
}
